/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import {
  Title,
  CloseContainer,
  ButtonContainer,
  SubmitButton,
  Link,
  Links,
  IconContainer,
} from "./ProfileModal.styles.js";

import Modal from "./Modal2";
import openToast from "../../utils/toast";
import Icon from "../../components/Icon";

import { logout } from "../../store/slices/businessUser/asyncThunks";
import { logoutRecipient } from "../../store/slices/authRecipient/asyncThunks";

import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as AccountSettings } from "../../assets/icons/settings.svg";
import { ReactComponent as AccountSettingsUnSelected } from "../../assets/icons/settingsUnSelected.svg";
import { ReactComponent as Wallet } from "../../assets/icons/wallet.svg";
import { ReactComponent as WalletUnSelected } from "../../assets/icons/walletUnSelected.svg";
import { ReactComponent as OrderHistory } from "../../assets/icons/clock.svg";
import { ReactComponent as OrderHistoryUnSelected } from "../../assets/icons/clockUnSelected.svg";
import { ReactComponent as Favorite } from "../../assets/icons/heart.svg";
import { ReactComponent as FavoriteUnSelected } from "../../assets/icons/heartUnSelected.svg";
import { ReactComponent as Dashboard } from "../../assets/icons/dashboard.svg";
import { ReactComponent as DashboardUnSelected } from "../../assets/icons/dashboardUnSelected.svg";
import { ReactComponent as Marketplace } from "../../assets/icons/market.svg";
import { ReactComponent as MarketplaceUnSelected } from "../../assets/icons/marketUnSelected.svg";
import { ReactComponent as Coupon } from "../../assets/icons/coupon.svg";
import { ReactComponent as CouponUnSelected } from "../../assets/icons/couponUnSelected.svg";
import { ReactComponent as Subscription } from "../../assets/icons/sub.svg";
import { ReactComponent as SubscriptionUnSelected } from "../../assets/icons/subUnSelected.svg";
import { ReactComponent as Recipients } from "../../assets/icons/usergroup.svg";
import { ReactComponent as RecipientsUnSelected } from "../../assets/icons/usergroupUnSelected.svg";
import { countClickAction } from "../../store/slices/common/asyncThunks";
import { checkPermission } from "../../utils/utils.js";
import { selectBusinessUserInfo } from "../../store/slices/businessUser/slice.js";
import { useSelector } from "react-redux";
import { businessUserRoleAction } from "../../utils/constants.js";

const ProfileModal = ({
  open,
  close,
  role,
  t,
  ar,
  fullName,
  businessId,
  recipientId,
}) => {
  const dispatch = useDispatch();
  const businessUser = useSelector(selectBusinessUserInfo);

  const toastId = useRef(null);

  const handleLogout = () => {
    if (businessId > 0) {
      dispatch(logout())
        .unwrap()
        .then(() => {
          close();
        })
        .catch((error) => {
          openToast(toastId, "logout-sidebar-modal", "error", t(error.message));
        });
    } else if (recipientId > 0) {
      dispatch(logoutRecipient())
        .unwrap()
        .then(() => {
          close();
        })
        .catch((error) => {
          openToast(toastId, "logout-sidebar-modal", "error", t(error.message));
        });
    }
  };

  const navLinks = [
    {
      to: "/admin-portal/dashboard",
      icon: <Dashboard height={24} width={24} />,
      iconUnSelected: <DashboardUnSelected height={24} width={24} />,
      label: "dashboard",
    },
    {
      to: "/admin-portal/marketplace",
      icon: <Marketplace height={24} width={24} />,
      iconUnSelected: <MarketplaceUnSelected height={24} width={24} />,
      label: "marketplace",
    },
    {
      to: "/admin-portal/recipients?page=1",
      icon: <Recipients height={24} width={24} />,
      iconUnSelected: <RecipientsUnSelected height={24} width={24} />,
      label: "recipients2",
    },
    {
      to: "/admin-portal/order-history?marketplacePage=1&giftsPage=1",
      icon: <OrderHistory height={24} width={24} />,
      iconUnSelected: <OrderHistoryUnSelected height={24} width={24} />,
      label: "my-orders",
    },
    {
      to: checkPermission(
        businessUser,
        businessUserRoleAction.get_bank_transfers
      )
        ? "/admin-portal/billing?billingsPage=1&bankTransfersPage=1"
        : "/admin-portal/billing?billingsPage=1",
      icon: <Wallet height={24} width={24} />,
      iconUnSelected: <WalletUnSelected height={24} width={24} />,
      label: "wallet",
    },
    {
      to: "/admin-portal/favorite",
      icon: <Favorite height={24} width={24} />,
      iconUnSelected: <FavoriteUnSelected height={24} width={24} />,
      label: "favorites",
    },
    {
      to: checkPermission(
        businessUser,
        businessUserRoleAction.get_subscriptions
      )
        ? "/admin-portal/subscriptions"
        : "/admin-portal/business-subscriptions?page=1",
      icon: <Subscription height={24} width={24} />,
      iconUnSelected: <SubscriptionUnSelected height={24} width={24} />,
      label: "subscriptions",
    },

    ...(checkPermission(businessUser, businessUserRoleAction.get_coupons)
      ? [
          {
            to: "/admin-portal/coupons",
            icon: <Coupon height={24} width={24} />,
            iconUnSelected: <CouponUnSelected height={24} width={24} />,
            label: "coupons",
          },
        ]
      : []),
    ...(checkPermission(businessUser, businessUserRoleAction.get_users)
      ? [
          {
            to: "/admin-portal/customers?page=1",
            icon: <Recipients />,
            iconUnSelected: <RecipientsUnSelected />,
            label: "customers",
          },
        ]
      : []),
  ];

  return (
    <Modal
      onClose={close}
      open={open}
      right
      width={"567px"}
      height={"100%"}
      padding={"5rem 6rem"}
      unset
      responsive
    >
      <CloseContainer onClick={close}>
        <CloseIcon fill="white" width={20} height={20} />
      </CloseContainer>
      <Title>
        {t("welcome")} {fullName.split(" ")[0]}
      </Title>
      <Links>
        {navLinks.map(({ to, icon, iconUnSelected, label }) => (
          <Link
            key={to}
            to={to}
            onClick={() => {
              if (label === "marketplace") {
                dispatch(countClickAction("marketplace"));
              }
            }}
            children={({ isActive }) => {
              return (
                <>
                  <IconContainer>
                    {isActive ? (
                      <Icon icon={icon} selectedLocale={ar} />
                    ) : (
                      <Icon icon={iconUnSelected} selectedLocale={ar} />
                    )}
                  </IconContainer>
                  {t(`${label}`)}
                </>
              );
            }}
          />
        ))}

        <Link
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          to={"/admin-portal/account-settings"}
          children={({ isActive }) => {
            return (
              <>
                <IconContainer>
                  {isActive ? (
                    <Icon
                      icon={<AccountSettings height={24} width={24} />}
                      selectedLocale={ar}
                    />
                  ) : (
                    <Icon
                      icon={
                        <AccountSettingsUnSelected height={24} width={24} />
                      }
                      selectedLocale={ar}
                    />
                  )}
                </IconContainer>
                {t("account-settings")}
              </>
            );
          }}
        />
      </Links>

      <ButtonContainer>
        <SubmitButton onClick={handleLogout}>{t("logout")}</SubmitButton>
      </ButtonContainer>
    </Modal>
  );
};

export default ProfileModal;
